/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { Injectable } from '@angular/core';
// import { UserApi } from '../custom/UserApi';

@Injectable()
export class DataService {
  private dataState: any = {};
  private authState: any = {};
  private nameMap: {};

  constructor(
    // private userApi: UserApi
  ) { }

  public set state(data: any) {
    this.dataState = data;
  }
  public get state(): any {
    return this.dataState;
  }
  public set authUser(data: any) {
    this.authState = data;
  }
  public get authUser(): any {
    if (!this.authState) {
      // return this.router.navigate(['login']);
    }
    return this.authState;
  }
  public getNameByID(id) {
    // TODO remove this
    if (!this.nameMap[id]) {
      // this.userApi.findById(id).subscribe((response) => {
      //   return this.nameMap[id] = response.firstName + ' ' + response.surname;
      // }, (error) => {

      // });
    }
    return this.nameMap[id];
  }
}
